export interface RouterList {
  components: Array<{
    name: string;
    language: string;
    experimentalChildren: Array<{
      path: string;
      hidden: boolean;
      description: string;
      experimental: boolean;
      label: string;
      zh: string;
    }>;
    children: Array<{
      cover: string;
      path: string;
      hidden: boolean;
      description: string;
      experimental: boolean;
      label: string;
      zh: string;
    }>;
  }>;
  intro: Array<{
    path: string;
    label: string;
    language: string;
    order: number;
    hidden: boolean;
    description: string;
    experimental: boolean;
  }>;
}

export const ROUTER_LIST:RouterList = {
  'intro'     : [
  {
    "path": "docs/introduce/en",
    "label": "Ant Design of Angular",
    "language": "en",
    "order": 0,
    "hidden": false,
    "description": "Angular Ant Design of Angular Component, An enterprise-class Angular UI component library based on Ant Design, all components are open source and free...",
    "experimental": false
  },
  {
    "path": "docs/getting-started/en",
    "label": "Getting Started",
    "language": "en",
    "order": 1,
    "hidden": false,
    "description": "Angular Getting Started Component, Ant Design of Angular is dedicated to providing a good development experience for programmers.The prerequisite of A...",
    "experimental": false
  },
  {
    "path": "docs/schematics/en",
    "label": "Schematics",
    "language": "en",
    "order": 2,
    "hidden": false,
    "description": "Angular Schematics Component, Using a CLI helps initialize projects, generate template codes and reduce development time.Themwc scaffolding is essenti...",
    "experimental": false
  },
  {
    "path": "docs/i18n/en",
    "label": "Internationalization",
    "language": "en",
    "order": 4,
    "hidden": false,
    "description": "Angular Internationalization Component, The default language of mwc is Chinese as of yet.\nIf you want to use other languages, you can follow the instr...",
    "experimental": false
  },
  {
    "path": "docs/universal/en",
    "label": "Server-side Rendering",
    "language": "en",
    "order": 5,
    "hidden": false,
    "description": "Angular Server-side Rendering Component, This guide assumes that you have already known about Server-side Rendering(SSR).You can also start your proje...",
    "experimental": false
  },
  {
    "path": "docs/customize-theme/en",
    "label": "Theme Customization",
    "language": "en",
    "order": 6,
    "hidden": false,
    "description": "Angular Theme Customization Component, Ant Design allows you to customize some basic design aspects in order to meet the needs of UI diversity from bu...",
    "experimental": false
  },
  {
    "path": "docs/customize-theme-variable/en",
    "label": "Dynamic Theme (Experimental)",
    "language": "en",
    "order": 6.1,
    "hidden": false,
    "description": "Angular Dynamic Theme (Experimental) Component, Except less customize theme, We also provide CSS Variable version to enable dynamic theme.This functio...",
    "experimental": false
  },
  {
    "path": "docs/global-config/en",
    "label": "Global Configuration",
    "language": "en",
    "order": 7,
    "hidden": false,
    "description": "Angular Global Configuration Component, We add a global configuration support to many components. You can define the default behavior of these compone...",
    "experimental": false
  },
  {
    "path": "docs/animations/en",
    "label": "Animations Switch",
    "language": "en",
    "order": 8,
    "hidden": false,
    "description": "Angular Animations Switch Component, MWC allows developers to turn off the animations. You can set animations' switch by adding corresponding directiv...",
    "experimental": false
  },
  {
    "path": "docs/direction/en",
    "label": "Direction",
    "language": "en",
    "order": 9,
    "hidden": false,
    "description": "Angular Direction Component, Set the direction (LTR / RTL).Set the dir attribute on the document body or html tag.Import the Angular CDK bidi module.S...",
    "experimental": false
  },
  {
    "path": "docs/recommendation/en",
    "label": "Resources",
    "language": "en",
    "order": 10,
    "hidden": false,
    "description": "Angular Resources Component, mwc-zorro-antd is essentially implementing Ant Design in Angular. We recommend you to use the following existing resource...",
    "experimental": false
  },
  {
    "path": "docs/faq/en",
    "label": "FAQ",
    "language": "en",
    "order": 11,
    "hidden": false,
    "description": "Angular FAQ Component, For more questions please search issues with FAQ tag.The size hello-world project of angular after gzip is about 30KB, the size...",
    "experimental": false
  },
  {
    "path": "docs/contributing/en",
    "label": "How to Contribute",
    "language": "en",
    "order": 12,
    "hidden": false,
    "description": "Angular How to Contribute Component, The following is a set of guidelines about making contributions to MWC. Please spend several minutes in reading t...",
    "experimental": false
  },
  {
    "path": "docs/changelog/en",
    "label": "Change Log",
    "language": "en",
    "order": 13,
    "hidden": false,
    "description": "Angular Change Log Component, mwc strictly follows Semantic Versioning 2.0.0.Weekly release: patch version at the end of every week for routine bugfix...",
    "experimental": false
  },
  {
    "path": "docs/migration-v15/en",
    "label": "v15 Migration Guide",
    "language": "en",
    "order": 15,
    "hidden": false,
    "description": "Angular v15 Migration Guide Component, This document will help you upgrade from mwc 14.x version to 15.x version.Make sure Node.js >= 14.20.0 or >= 16...",
    "experimental": false
  },
  {
    "path": "docs/join/en",
    "label": "Join us",
    "language": "en",
    "order": 16,
    "hidden": true,
    "description": "Angular Join us Component, ",
    "experimental": false
  }
],
  'components': [
  {
    "name": "General",
    "language": "en",
    "children": [
      {
        "label": "Button",
        "path": "components/button/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/fNUKzY1sk/Button.svg",
        "description": "Angular Button Component, To trigger an operation.A button means an operation (or a series of operations). Clicking a button will trigger correspondin..."
      },
      {
        "label": "Icon",
        "path": "components/icon/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/rrwbSt3FQ/Icon.svg",
        "description": "Angular Icon Component, Semantic vector graphics.We are still adding icons right now, syncing to antd.We synced to Ant Design and replaced font icons ..."
      },
      {
        "label": "Typography",
        "path": "components/typography/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/GOM1KQ24O/Typography.svg",
        "description": "Angular Typography Component, Basic text writing, including headings, body text, lists, and more.When need to display title or paragraph contents in A..."
      }
    ],
    "experimentalChildren": [
      {
        "label": "Pipes",
        "path": "experimental/pipes/en",
        "zh": "",
        "experimental": true,
        "hidden": false,
        "description": "Angular Pipes Component, MWC experiments are features that are released but not yet considered stable or production readyDevelopers and users can opt-..."
      }
    ]
  },
  {
    "name": "Layout",
    "language": "en",
    "children": [
      {
        "label": "Divider",
        "path": "components/divider/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/5swjECahe/Divider.svg",
        "description": "Angular Divider Component, A divider line separates different content.Divide sections of article.Divide inline text and links such as the operation co..."
      },
      {
        "label": "Grid",
        "path": "components/grid/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/5rWLU27so/Grid.svg",
        "description": "Angular Grid Component, 24 Grids System。In most business situations, Ant Design needs to solve a lot of information storage problems within the design..."
      },
      {
        "label": "Layout",
        "path": "components/layout/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/hzEndUVEx/Layout.svg",
        "description": "Angular Layout Component, Handling the overall layout of a page.The first level navigation is inclined left near a logo, and the secondary menu is inc..."
      },
      {
        "label": "Space",
        "path": "components/space/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/wc6%263gJ0Y8/Space.svg",
        "description": "Angular Space Component, Set components spacing.Avoid components clinging together and set a unified space."
      }
    ],
    "experimentalChildren": [
      {
        "label": "Resizable",
        "path": "experimental/resizable/en",
        "zh": "",
        "experimental": true,
        "hidden": false,
        "description": "Angular Resizable Component, MWC experiments are features that are released but not yet considered stable or production readyDevelopers and users can ..."
      }
    ]
  },
  {
    "name": "Navigation",
    "language": "en",
    "children": [
      {
        "label": "Affix",
        "path": "components/affix/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/tX6-md4H6/Affix.svg",
        "description": "Angular Affix Component, Make an element stick to viewport.When user browses a long web page, some content need to stick to the viewport. This is comm..."
      },
      {
        "label": "Breadcrumb",
        "path": "components/breadcrumb/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/9Ltop8JwH/Breadcrumb.svg",
        "description": "Angular Breadcrumb Component, A breadcrumb displays the current location within a hierarchy. It allows going back to states higher up in the hierarchy..."
      },
      {
        "label": "Dropdown",
        "path": "components/dropdown/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/eedWN59yJ/Dropdown.svg",
        "description": "Angular Dropdown Component, A dropdown list.If there are too many operations to display, you can wrap them in a Dropdown. By clicking/hovering on the ..."
      },
      {
        "label": "Menu",
        "path": "components/menu/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/3XZcjGpvK/Menu.svg",
        "description": "Angular Menu Component, Menu list of Navigation.Navigation menu is important for a website, it helps users jump from one site section to another quick..."
      },
      {
        "label": "PageHeader",
        "path": "components/page-header/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/6bKE0Cq0R/PageHeader.svg",
        "description": "Angular PageHeader Component, A header with common actions and design elements built in.PageHeader can be used to highlight the page topic, display im..."
      },
      {
        "label": "Pagination",
        "path": "components/pagination/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/1vqv2bj68/Pagination.svg",
        "description": "Angular Pagination Component, A long list can be divided into several pages by Pagination, and only one page will be loaded at a time.When it will tak..."
      },
      {
        "label": "Steps",
        "path": "components/steps/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/UZYqMizXHaj/Steps.svg",
        "description": "Angular Steps Component, Steps is a navigation bar that guides users through the steps of a task.When the task is complicated or has a certain sequenc..."
      }
    ],
    "experimentalChildren": []
  },
  {
    "name": "Data Entry",
    "language": "en",
    "children": [
      {
        "label": "Autocomplete",
        "path": "components/auto-complete/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/qtJm4yt45/AutoComplete.svg",
        "description": "Angular Autocomplete Component, Autocomplete function of input field.When there is a need for autocomplete functionality."
      },
      {
        "label": "Cascader",
        "path": "components/cascader/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/UdS8y8xyZ/Cascader.svg",
        "description": "Angular Cascader Component, Cascade selection box.When you need to select from a set of a hierarchical structure. Such as province/city/district, comp..."
      },
      {
        "label": "Checkbox",
        "path": "components/checkbox/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/8nbVbHEm_/CheckBox.svg",
        "description": "Angular Checkbox Component, Checkbox.Used for selecting multiple values from several options.If you use only one checkbox, it is the same as using Swi..."
      },
      {
        "label": "DatePicker",
        "path": "components/date-picker/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/RT_USzA48/DatePicker.svg",
        "description": "Angular DatePicker Component, To select or input a date.By clicking the input box, you can select a date from a popup calendar.Note: Some of mwc-date-..."
      },
      {
        "label": "Form",
        "path": "components/form/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/ORmcdeaoO/Form.svg",
        "description": "Angular Form Component, Form is used to collect, validate, and submit the user input, usually contains various form items including checkbox, radio, i..."
      },
      {
        "label": "Input",
        "path": "components/input/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/xS9YEJhfe/Input.svg",
        "description": "Angular Input Component, A basic widget for getting the user input is a text field.\nKeyboard and mouse can be used for providing or changing data.A us..."
      },
      {
        "label": "InputNumber",
        "path": "components/input-number/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/XOS8qZ0kU/InputNumber.svg",
        "description": "Angular InputNumber Component, Enter a number within certain range with the mouse or keyboard.When a numeric value needs to be provided.You can get in..."
      },
      {
        "label": "Mention",
        "path": "components/mention/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/jPE-itMFM/Mentions.svg",
        "description": "Angular Mention Component, Mention component.When need to mention someone or something.Trigger elementCustomize the suggestion template"
      },
      {
        "label": "Radio",
        "path": "components/radio/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/8cYb5seNB/Radio.svg",
        "description": "Angular Radio Component, Radio.Used to select a single state in multiple options.The difference between Select is that Radio is visible to user and ca..."
      },
      {
        "label": "Rate",
        "path": "components/rate/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/R5uiIWmxe/Rate.svg",
        "description": "Angular Rate Component, Rate component.Show evaluation.A quick rating operation on something."
      },
      {
        "label": "Select",
        "path": "components/select/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/_0XzgOis7/Select.svg",
        "description": "Angular Select Component, Select component to select value from options.A dropdown menu for displaying choices - an elegant alternative to the native "
      },
      {
        "label": "Slider",
        "path": "components/slider/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/HZ3meFc6W/Silder.svg",
        "description": "Angular Slider Component, A Slider component for displaying current value and intervals in range.To input a value in a range."
      },
      {
        "label": "Switch",
        "path": "components/switch/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/zNdJQMhfm/Switch.svg",
        "description": "Angular Switch Component, Switching Selector.If you need to represent the switching between two states or on-off state.The difference between Switch a..."
      },
      {
        "label": "TimePicker",
        "path": "components/time-picker/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/h04Zsl98I/TimePicker.svg",
        "description": "Angular TimePicker Component, To select/input a time.By clicking the input box, you can select a time from a popup panel."
      },
      {
        "label": "Transfer",
        "path": "components/transfer/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/QAXskNI4G/Transfer.svg",
        "description": "Angular Transfer Component, Double column transfer choice box.Transfer the elements between two columns intuitively and efficiently.The left column is..."
      },
      {
        "label": "TreeSelect",
        "path": "components/tree-select/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/Ax4DA0njr/TreeSelect.svg",
        "description": "Angular TreeSelect Component, Tree selection control.TreeSelect is similar to Select, but the values are provided in a tree like structure.\nAny data w..."
      },
      {
        "label": "Upload",
        "path": "components/upload/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/QaeBt_ZMg/Upload.svg",
        "description": "Angular Upload Component, Upload file by selecting or dragging.Uploading is publishing information (web pages, text, pictures, video, etc.) to a remot..."
      }
    ],
    "experimentalChildren": [
      {
        "label": "Code Editor",
        "path": "experimental/code-editor/en",
        "zh": "",
        "experimental": true,
        "hidden": false,
        "description": "Angular Code Editor Component, MWC experiments are features that are released but not yet considered stable or production readyDevelopers and users ca..."
      },
      {
        "label": "Cron Expression",
        "path": "experimental/cron-expression/en",
        "zh": "cron form",
        "experimental": true,
        "hidden": false,
        "description": "Angular cron form 组件，MWC experiments are features that are released but not yet considered stable or production readyDevelopers and users can opt-in i..."
      }
    ]
  },
  {
    "name": "Data Display",
    "language": "en",
    "children": [
      {
        "label": "Avatar",
        "path": "components/avatar/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/aBcnbw68hP/Avatar.svg",
        "description": "Angular Avatar Component, Avatars can be used to represent people or objects. It supports images, Icons, or letters."
      },
      {
        "label": "Badge",
        "path": "components/badge/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/6%26GF9WHwvY/Badge.svg",
        "description": "Angular Badge Component, Small numerical value or status descriptor for UI elements.Badge normally appears in proximity to notifications or user avata..."
      },
      {
        "label": "Calendar",
        "path": "components/calendar/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/dPQmLq08DI/Calendar.svg",
        "description": "Angular Calendar Component, Container for displaying data in calendar form.When data is in the form of dates, such as schedules, timetables, prices ca..."
      },
      {
        "label": "Card",
        "path": "components/card/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/keNB-R8Y9/Card.svg",
        "description": "Angular Card Component, Simple rectangular container.A card can be used to display content related to a single subject. The content can consist of mul..."
      },
      {
        "label": "Carousel",
        "path": "components/carousel/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/%24C9tmj978R/Carousel.svg",
        "description": "Angular Carousel Component, A carousel component. Scales with its container.When there is a group of content on the same level.When there is insuffici..."
      },
      {
        "label": "Collapse",
        "path": "components/collapse/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/IxH16B9RD/Collapse.svg",
        "description": "Angular Collapse Component, A content area which can be collapsed and expanded.Can be used to group or hide complex regions to keep the page clean.Acc..."
      },
      {
        "label": "Comment",
        "path": "components/comment/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/ILhxpGzBO/Comment.svg",
        "description": "Angular Comment Component, A comment displays user feedback and discussion to website content.Comments can be used to enable discussions on an entity ..."
      },
      {
        "label": "Descriptions",
        "path": "components/descriptions/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/MjtG9_FOI/Descriptions.svg",
        "description": "Angular Descriptions Component, Display multiple read-only fields in groups.Commonly displayed on the details page."
      },
      {
        "label": "Empty",
        "path": "components/empty/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/MNbKfLBVb/Empty.svg",
        "description": "Angular Empty Component, Empty state placeholder.When there is no data provided, display for friendly tips.The mwcEmpty interface has properties as fo..."
      },
      {
        "label": "Image",
        "path": "components/image/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/D1dXz9PZqa/image.svg",
        "description": "Angular Image Component, Previewable image.When you need to display pictures.Display when loading a large image or fault tolerant handling when loadin..."
      },
      {
        "label": "List",
        "path": "components/list/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/5FrZKStG_/List.svg",
        "description": "Angular List Component, Simple List.A list can be used to display content related to a single subject. The content can consist of multiple elements of..."
      },
      {
        "label": "Popover",
        "path": "components/popover/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/1PNL1p_cO/Popover.svg",
        "description": "Angular Popover Component, The floating card popped by clicking or hovering.A simple popup menu to provide extra information or operations.Comparing w..."
      },
      {
        "label": "QRCode",
        "path": "components/qr-code/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://mdn.alipayobjects.com/huamei_7uahnr/afts/img/A*cJopQrf0ncwAAAAAAAAAAAAADrJ8AQ/original",
        "description": "Angular QRCode Component, Used when the link needs to be converted into a QR Code.mwcValue has a conservative upper limit of 738 or fewer strings. If ..."
      },
      {
        "label": "Segmented",
        "path": "components/segmented/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/bmw-prod/a3ff040f-24ba-43e0-92e9-c845df1612ad.svg",
        "description": "Angular Segmented Component, When displaying multiple options and user can select a single option;When switching the selected option, the content of t..."
      },
      {
        "label": "Statistic",
        "path": "components/statistic/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/rcBNhLBrKbE/Statistic.svg",
        "description": "Angular Statistic Component, Display statistic number.When want to highlight some data.When want to display statistic data with description."
      },
      {
        "label": "Table",
        "path": "components/table/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/f-SbcX2Lx/Table.svg",
        "description": "Angular Table Component, A table displays rows of data.To display a collection of structured data.To sort, search, paginate and filter data.The Table ..."
      },
      {
        "label": "Tabs",
        "path": "components/tabs/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/lkI2hNEDr2V/Tabs.svg",
        "description": "Angular Tabs Component, Tabs make it easy to switch between different views.Ant Design has 3 types of Tabs for different situations.Card Tabs: for man..."
      },
      {
        "label": "Tag",
        "path": "components/tag/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/cH1BOLfxC/Tag.svg",
        "description": "Angular Tag Component, Tag for categorizing or markup.It can be used to tag by dimension or property.\nIt can be used to tag by dimension or property.W..."
      },
      {
        "label": "Timeline",
        "path": "components/timeline/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/antfincdn/vJmo00mmgR/Timeline.svg",
        "description": "Angular Timeline Component, Vertical display timeline.When a series of information needs to be ordered by time (ascend or descend).When you need a tim..."
      },
      {
        "label": "Tooltip",
        "path": "components/tooltip/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/Vyyeu8jq2/Tooltp.svg",
        "description": "Angular Tooltip Component, A simple text popup tip.The Tooltip doesn't support complex text or operations. The tip is shown on mouse enter and is hidd..."
      },
      {
        "label": "Tree",
        "path": "components/tree/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/Xh-oWqg9k/Tree.svg",
        "description": "Angular Tree Component, Almost anything can be represented in a tree structure. Examples include directories, organization hierarchies, biological cla..."
      },
      {
        "label": "Tree View",
        "path": "components/tree-view/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/Xh-oWqg9k/Tree.svg",
        "description": "Angular Tree View Component, More basic Tree component, allowing each of its parts to be defined in the template, and state to be managed manually.\nWi..."
      }
    ],
    "experimentalChildren": [
      {
        "label": "Image",
        "path": "experimental/experimental-image/en",
        "zh": "",
        "experimental": true,
        "hidden": false,
        "description": "Angular Image Component, MWC experiments are features that are released but not yet considered stable or production readyDevelopers and users can opt-..."
      },
      {
        "label": "Graph",
        "path": "experimental/graph/en",
        "zh": "",
        "experimental": true,
        "hidden": false,
        "description": "Angular Graph Component, MWC experiments are features that are released but not yet considered stable or production readyDevelopers and users can opt-..."
      }
    ]
  },
  {
    "name": "Feedback",
    "language": "en",
    "children": [
      {
        "label": "Alert",
        "path": "components/alert/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/8emPa3fjl/Alert.svg",
        "description": "Angular Alert Component, Alert component for feedback.When you need to show alert messages to users.When you need a persistent static container which ..."
      },
      {
        "label": "Drawer",
        "path": "components/drawer/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/7z8NJQhFb/Drawer.svg",
        "description": "Angular Drawer Component, A Drawer is a panel that is typically overlaid on top of a page and slides in from the side. It contains a set of informatio..."
      },
      {
        "label": "Message",
        "path": "components/message/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/hAkKTIW0K/Message.svg",
        "description": "Angular Message Component, Display global messages as feedback in response to user operations.To provide feedback such as success, warning, error etc."
      },
      {
        "label": "Modal",
        "path": "components/modal/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/3StSdUlSH/Modal.svg",
        "description": "Angular Modal Component, Modal dialogs.When requiring users to interact with the application without jumping to a new page to interrupt the user's wor..."
      },
      {
        "label": "Notification",
        "path": "components/notification/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/Jxm5nw61w/Notification.svg",
        "description": "Angular Notification Component, Display a notification message globally.To display a notification message at any of the four corners of the viewport. ..."
      },
      {
        "label": "Popconfirm",
        "path": "components/popconfirm/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/fjMCD9xRq/Popconfirm.svg",
        "description": "Angular Popconfirm Component, A simple and compact confirmation dialog of an action.A simple and compact dialog used for asking for user confirmation."
      },
      {
        "label": "Progress",
        "path": "components/progress/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/xqsDu4ZyR/Progress.svg",
        "description": "Angular Progress Component, Display the current progress of an operation flow.If it will take a long time to complete an operation, you can use Progre..."
      },
      {
        "label": "Result",
        "path": "components/result/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/9nepwjaLa/Result.svg",
        "description": "Angular Result Component, Used to feed back the results of a series of operational tasks.Use when important operations need to inform the user to proc..."
      },
      {
        "label": "Skeleton",
        "path": "components/skeleton/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/KpcciCJgv/Skeleton.svg",
        "description": "Angular Skeleton Component, Provide a placeholder while you wait for content to load or visualize content that doesn't exist yet.When resource needs l..."
      },
      {
        "label": "Spin",
        "path": "components/spin/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/LBcJqCPRv/Spin.svg",
        "description": "Angular Spin Component, A spinner for displaying loading state of a page or a section.When part of the page is waiting for asynchronous data or during..."
      }
    ],
    "experimentalChildren": []
  },
  {
    "name": "Other",
    "language": "en",
    "children": [
      {
        "label": "Anchor",
        "path": "components/anchor/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/_1-C1JwsC/Anchor.svg",
        "description": "Angular Anchor Component, Hyperlinks to scroll on one page.For displaying anchor hyperlinks on page and jumping between them."
      },
      {
        "label": "BackTop",
        "path": "components/back-top/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://gw.alipayobjects.com/zos/alicdn/tJZ5jbTwX/BackTop.svg",
        "description": "Angular BackTop Component, mwc-back-top makes it easy to go back to the top of the page.When the page content is very long.When you need to go back to..."
      },
      {
        "label": "WaterMark",
        "path": "components/water-mark/en",
        "zh": "",
        "experimental": false,
        "hidden": false,
        "cover": "https://img.alicdn.com/imgextra/i3/O1CN0194FGAd1FlrwQShfR8_!!6000000000528-0-tps-952-502.jpg",
        "description": "Angular WaterMark Component, Add specific text or patterns to the page.Use when the page needs to be watermarked to identify the copyright.Suitable fo..."
      }
    ],
    "experimentalChildren": []
  }
]
};
export const DEMO_ROUTES = [
  {'path': 'components/affix', 'loadChildren': () => import('./affix/index.module').then(m => m.MwcDemoAffixModule)},
  {'path': 'components/alert', 'loadChildren': () => import('./alert/index.module').then(m => m.MwcDemoAlertModule)},
  {'path': 'components/anchor', 'loadChildren': () => import('./anchor/index.module').then(m => m.MwcDemoAnchorModule)},
  {'path': 'components/auto-complete', 'loadChildren': () => import('./auto-complete/index.module').then(m => m.MwcDemoAutoCompleteModule)},
  {'path': 'components/avatar', 'loadChildren': () => import('./avatar/index.module').then(m => m.MwcDemoAvatarModule)},
  {'path': 'components/back-top', 'loadChildren': () => import('./back-top/index.module').then(m => m.MwcDemoBackTopModule)},
  {'path': 'components/badge', 'loadChildren': () => import('./badge/index.module').then(m => m.MwcDemoBadgeModule)},
  {'path': 'components/breadcrumb', 'loadChildren': () => import('./breadcrumb/index.module').then(m => m.MwcDemoBreadcrumbModule)},
  {'path': 'components/button', 'loadChildren': () => import('./button/index.module').then(m => m.MwcDemoButtonModule)},
  {'path': 'components/calendar', 'loadChildren': () => import('./calendar/index.module').then(m => m.MwcDemoCalendarModule)},
  {'path': 'components/card', 'loadChildren': () => import('./card/index.module').then(m => m.MwcDemoCardModule)},
  {'path': 'components/carousel', 'loadChildren': () => import('./carousel/index.module').then(m => m.MwcDemoCarouselModule)},
  {'path': 'components/cascader', 'loadChildren': () => import('./cascader/index.module').then(m => m.MwcDemoCascaderModule)},
  {'path': 'components/checkbox', 'loadChildren': () => import('./checkbox/index.module').then(m => m.MwcDemoCheckboxModule)},
  {'path': 'experimental/code-editor', 'loadChildren': () => import('./code-editor/index.module').then(m => m.MwcDemoCodeEditorModule)},
  {'path': 'components/collapse', 'loadChildren': () => import('./collapse/index.module').then(m => m.MwcDemoCollapseModule)},
  {'path': 'components/comment', 'loadChildren': () => import('./comment/index.module').then(m => m.MwcDemoCommentModule)},
  {'path': 'experimental/cron-expression', 'loadChildren': () => import('./cron-expression/index.module').then(m => m.MwcDemoCronExpressionModule)},
  {'path': 'components/date-picker', 'loadChildren': () => import('./date-picker/index.module').then(m => m.MwcDemoDatePickerModule)},
  {'path': 'components/descriptions', 'loadChildren': () => import('./descriptions/index.module').then(m => m.MwcDemoDescriptionsModule)},
  {'path': 'components/divider', 'loadChildren': () => import('./divider/index.module').then(m => m.MwcDemoDividerModule)},
  {'path': 'components/drawer', 'loadChildren': () => import('./drawer/index.module').then(m => m.MwcDemoDrawerModule)},
  {'path': 'components/dropdown', 'loadChildren': () => import('./dropdown/index.module').then(m => m.MwcDemoDropdownModule)},
  {'path': 'components/empty', 'loadChildren': () => import('./empty/index.module').then(m => m.MwcDemoEmptyModule)},
  {'path': 'experimental/experimental-image', 'loadChildren': () => import('./experimental-image/index.module').then(m => m.MwcDemoExperimentalImageModule)},
  {'path': 'components/form', 'loadChildren': () => import('./form/index.module').then(m => m.MwcDemoFormModule)},
  {'path': 'experimental/graph', 'loadChildren': () => import('./graph/index.module').then(m => m.MwcDemoGraphModule)},
  {'path': 'components/grid', 'loadChildren': () => import('./grid/index.module').then(m => m.MwcDemoGridModule)},
  {'path': 'components/icon', 'loadChildren': () => import('./icon/index.module').then(m => m.MwcDemoIconModule)},
  {'path': 'components/image', 'loadChildren': () => import('./image/index.module').then(m => m.MwcDemoImageModule)},
  {'path': 'components/input', 'loadChildren': () => import('./input/index.module').then(m => m.MwcDemoInputModule)},
  {'path': 'components/input-number', 'loadChildren': () => import('./input-number/index.module').then(m => m.MwcDemoInputNumberModule)},
  {'path': 'components/layout', 'loadChildren': () => import('./layout/index.module').then(m => m.MwcDemoLayoutModule)},
  {'path': 'components/list', 'loadChildren': () => import('./list/index.module').then(m => m.MwcDemoListModule)},
  {'path': 'components/mention', 'loadChildren': () => import('./mention/index.module').then(m => m.MwcDemoMentionModule)},
  {'path': 'components/menu', 'loadChildren': () => import('./menu/index.module').then(m => m.MwcDemoMenuModule)},
  {'path': 'components/message', 'loadChildren': () => import('./message/index.module').then(m => m.MwcDemoMessageModule)},
  {'path': 'components/modal', 'loadChildren': () => import('./modal/index.module').then(m => m.MwcDemoModalModule)},
  {'path': 'components/notification', 'loadChildren': () => import('./notification/index.module').then(m => m.MwcDemoNotificationModule)},
  {'path': 'components/page-header', 'loadChildren': () => import('./page-header/index.module').then(m => m.MwcDemoPageHeaderModule)},
  {'path': 'components/pagination', 'loadChildren': () => import('./pagination/index.module').then(m => m.MwcDemoPaginationModule)},
  {'path': 'experimental/pipes', 'loadChildren': () => import('./pipes/index.module').then(m => m.MwcDemoPipesModule)},
  {'path': 'components/popconfirm', 'loadChildren': () => import('./popconfirm/index.module').then(m => m.MwcDemoPopconfirmModule)},
  {'path': 'components/popover', 'loadChildren': () => import('./popover/index.module').then(m => m.MwcDemoPopoverModule)},
  {'path': 'components/progress', 'loadChildren': () => import('./progress/index.module').then(m => m.MwcDemoProgressModule)},
  {'path': 'components/qr-code', 'loadChildren': () => import('./qr-code/index.module').then(m => m.MwcDemoQrCodeModule)},
  {'path': 'components/radio', 'loadChildren': () => import('./radio/index.module').then(m => m.MwcDemoRadioModule)},
  {'path': 'components/rate', 'loadChildren': () => import('./rate/index.module').then(m => m.MwcDemoRateModule)},
  {'path': 'experimental/resizable', 'loadChildren': () => import('./resizable/index.module').then(m => m.MwcDemoResizableModule)},
  {'path': 'components/result', 'loadChildren': () => import('./result/index.module').then(m => m.MwcDemoResultModule)},
  {'path': 'components/segmented', 'loadChildren': () => import('./segmented/index.module').then(m => m.MwcDemoSegmentedModule)},
  {'path': 'components/select', 'loadChildren': () => import('./select/index.module').then(m => m.MwcDemoSelectModule)},
  {'path': 'components/skeleton', 'loadChildren': () => import('./skeleton/index.module').then(m => m.MwcDemoSkeletonModule)},
  {'path': 'components/slider', 'loadChildren': () => import('./slider/index.module').then(m => m.MwcDemoSliderModule)},
  {'path': 'components/space', 'loadChildren': () => import('./space/index.module').then(m => m.MwcDemoSpaceModule)},
  {'path': 'components/spin', 'loadChildren': () => import('./spin/index.module').then(m => m.MwcDemoSpinModule)},
  {'path': 'components/statistic', 'loadChildren': () => import('./statistic/index.module').then(m => m.MwcDemoStatisticModule)},
  {'path': 'components/steps', 'loadChildren': () => import('./steps/index.module').then(m => m.MwcDemoStepsModule)},
  {'path': 'components/switch', 'loadChildren': () => import('./switch/index.module').then(m => m.MwcDemoSwitchModule)},
  {'path': 'components/table', 'loadChildren': () => import('./table/index.module').then(m => m.MwcDemoTableModule)},
  {'path': 'components/tabs', 'loadChildren': () => import('./tabs/index.module').then(m => m.MwcDemoTabsModule)},
  {'path': 'components/tag', 'loadChildren': () => import('./tag/index.module').then(m => m.MwcDemoTagModule)},
  {'path': 'components/time-picker', 'loadChildren': () => import('./time-picker/index.module').then(m => m.MwcDemoTimePickerModule)},
  {'path': 'components/timeline', 'loadChildren': () => import('./timeline/index.module').then(m => m.MwcDemoTimelineModule)},
  {'path': 'components/tooltip', 'loadChildren': () => import('./tooltip/index.module').then(m => m.MwcDemoTooltipModule)},
  {'path': 'components/transfer', 'loadChildren': () => import('./transfer/index.module').then(m => m.MwcDemoTransferModule)},
  {'path': 'components/tree', 'loadChildren': () => import('./tree/index.module').then(m => m.MwcDemoTreeModule)},
  {'path': 'components/tree-select', 'loadChildren': () => import('./tree-select/index.module').then(m => m.MwcDemoTreeSelectModule)},
  {'path': 'components/tree-view', 'loadChildren': () => import('./tree-view/index.module').then(m => m.MwcDemoTreeViewModule)},
  {'path': 'components/typography', 'loadChildren': () => import('./typography/index.module').then(m => m.MwcDemoTypographyModule)},
  {'path': 'components/upload', 'loadChildren': () => import('./upload/index.module').then(m => m.MwcDemoUploadModule)},
  {'path': 'components/water-mark', 'loadChildren': () => import('./water-mark/index.module').then(m => m.MwcDemoWaterMarkModule)},

];
